import React, { useState, useEffect } from 'react';
import arrow from "../assets/images/arrow.png";
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { toast } from 'react-toastify';

import { getPrograms } from '../services/ProgramApi';
import LoadingSpinner from './LoadingSpinner';
import config from '../config/config';

var settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  initialSlide: 0,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2
      }
    }
  ]
};

const ProgramSlider = () => {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const programsResponse = await getPrograms();
      setPrograms(programsResponse.data.data || []);
    } catch (error) {
      toast.error("Failed to fetch Program data");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }


  return (
    <Slider className='single-items' {...settings}>
      {programs.map((program, index) => (
        <div className='imag-title position-relative' key={program.id || index}>
          <Link to={`/course/${program.id}`}>
            <h3>{program.program_name}</h3>
            <img src={`${config.Image_Base_URL}${program.program_image}`} className='w-100 pro_image' alt={program.program_name} />
            <div className='arrow_link'><img src={arrow} width={14} alt="link" /></div>
          </Link>
        </div>
      ))}
    </Slider>
  );
}

export default ProgramSlider;
